/*
 * @LastEditors: ttheitao
 * @Description: 桌面图标
 * @FilePath: \onetab\src\store\bookmarks.ts
 * @Date: 2024-03-19 17:28:10
 * @LastEditTime: 2024-08-02 13:55:04
 * @Author: lisushuang
 */

import { computed, reactive } from 'vue';
import { settings } from './settings';
import {
  addBookmark,
  addCategory,
  getBookmarks,
  getCategories,
  getDefaultIcons,
  syncToLocal,
  syncToServer,
} from '@/api/baseApi';
import { user } from './user';
import { IKeyValue } from '@/lib/IType';

export enum sizes {
  Big,
  Wide,
  Middle,
  Small,
}

export interface category {
  name: string;
  color: string;
  icon: string;
  active: boolean;
  is_owner: boolean;
  uuid: string;
  is_share: number,

  bookmarks: Array<bookmark>;
}

export interface bookmark {
  name: string;
  color: string;
  url: string;
  icon: string;
  describe: string;
  size: sizes;
  order: number;
  children: Array<bookmark> | undefined;
  isComponent: boolean | undefined;
  componentName: string | undefined;
  componentConfig: unknown | undefined;
}

export const bookmarks = reactive({
  categories: <Array<category>>[
    // {
    //   name: "主页",
    //   color: "white",
    //   icon: "Home",
    //   bookmarks: [
    //     {
    //       name: "百度搜索",
    //       url: "https://www.baidu.com",
    //       describe: "baidu",
    //       size: sizes.Small,
    //       icon: "https://www.baidu.com/favicon.ico",
    //     },
    //     {
    //       name: "必应搜索",
    //       url: "https://www.bing.com",
    //       size: sizes.Small,
    //       icon: "https://www.bing.com/favicon.ico",
    //     },
    //     {
    //       name: "微软官网",
    //       url: "https://www.microsoft.com",
    //       size: sizes.Small,
    //       icon: "https://www.microsoft.com/favicon.ico",
    //     },
    //     {
    //       name: "筑云官网",
    //       url: "https://www.bimcc.net/",
    //       size: sizes.Small,
    //       icon: "https://www.bimcc.net/wp-content/uploads/2019/07/cropped-2018LOGO_%E5%9B%BE%E6%96%87_%E8%8B%B1%E6%96%87_V2_1771X713-192x192.png",
    //     },
    //   ],
    // },
  ],

  bottomColumn: <Array<category>>[],
  oldActive: null,
  gotoMark(info: bookmark) {
    window['_paq'].push([
      'trackEvent',
      '书签',
      '点击',
      `${user.email}|${info.url}|${info.name}`,
      1,
    ]);
    if (settings.newBookmark) {
      window.open(info.url);
    } else {
      window.location.href = info.url;
    }
  },

  getActive() {
    return this.categories.find((item) => item.active);
  },

  setActive(item) {
    this.categories.forEach((element) => {
      element.active = false;
    });

    item.active = true;
    localStorage.setItem('category', JSON.stringify(item));
  },

  setValue(value) {
    this.categories = [];

    value.forEach((element) => {
      this.categories.push(element);
    });
  },

  addOneToActive(item) {
    this.categories.forEach((element) => {
      if (element.active) {
        element.bookmarks.push(item);
      }
    });
  },

  removeOneInActive(uuid) {
    this.categories.forEach((element) => {
      if (element.active) {
        element.bookmarks.forEach((book, bindex) => {
          if (book.uuid === uuid) {
            element.bookmarks.splice(bindex, 1);
          }
        });
      }
    });
  },

  changeOnInActive(item) {
    this.categories.forEach((element) => {
      if (element.active) {
        element.bookmarks.forEach((book, bindex) => {
          if (book.uuid === item.uuid) {
            element.bookmarks[bindex] = item;
          }
        });
      }
    });
  },

  addCategory(item) {
    this.categories.push(item);
  },
  updateCategory(item) {
    const index = this.categories.findIndex((el) => {
      return el.uuid === item.uuid;
    });
    // this.categories[index].name = item?.name ?? '';
    // this.categories[index].icon = item?.icon ?? '';
    // this.categories[index].bookmarks = item?.bookmarks ?? [];
    for (const key in item) {
      this.categories[index][key] = item[key];
    }
  },
  delCategory(uuid: string) {
    const index = this.categories.findIndex((el) => {
      return el.uuid === uuid;
    });
    this.categories.splice(index, 1);
  },
});

export const activeCatetory = computed(() => {
  const active = bookmarks.categories.find((item) => item.active);
  return active ? active.bookmarks : [];
});

/**
 * @description: 刷新列表
 * @return {*}
 */
export const refresh = async () => {
  let categories = await getCategories();

  if (categories?.length === 0) {
    try {
      await syncToLocal();
      categories = await getCategories();
    } catch (err) {
      console.error(err);
    }
  }

  if (categories?.length === 0) {
    const cat = {
      name: '主页',
      icon: 'icon-onetabicon-19',
      color: 'white',
      order: 1,
    };
    const newCat = await addCategory(cat, false);
    categories.push(newCat);

    // const bms: any = [
    //   {
    //     name: '知乎',
    //     url: 'https://www.zhihu.com/',
    //     category_uuid: newCat.uuid,
    //     icon: 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/708e4b8f56d56efb245497c91a961e16.png',
    //     type: 1,
    //   },
    //   {
    //     name: '今日头条',
    //     url: 'https://www.toutiao.com/',
    //     category_uuid: newCat.uuid,
    //     icon: 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/0f8e7d8d834093ca96be586e194c916a.png',
    //     type: 1,
    //   },
    //   {
    //     name: '有道翻译',
    //     url: 'https://fanyi.youdao.com/',
    //     category_uuid: newCat.uuid,
    //     icon: 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/7346792cfb665096a124da90fd2c12ac.png',
    //     type: 1,
    //   },
    //   {
    //     name: '飞椽AI',
    //     url: 'https://mitab.bimcc.net/ai/',
    //     category_uuid: newCat.uuid,
    //     icon: 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/ai_logo.png',
    //     type: 3,
    //   },
    //   {
    //     name: '文档',
    //     url: 'http://mitab.bimcc.net/nodes/',
    //     category_uuid: newCat.uuid,
    //     icon: 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/img1/2ac23d53-27ef-2858-c288-82c35c8e48a6.png',
    //     type: 3,
    //   },
    //   {
    //     name: '日历',
    //     url: 'http://mitab.bimcc.net/calender/',
    //     category_uuid: newCat.uuid,
    //     icon: 'http://mitab.bimcc.net/calender/logo.png',
    //     type: 3,
    //   },
    //   // 业务应用
    //   {
    //     name: '飞椽云',
    //     url: 'https://newsaas.bimcc.com/',
    //     category_uuid: newCat.uuid,
    //     icon: 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/img1/clipboard_20240521_060154.png',
    //     type: 3,
    //   },
    //   // 工具

    //   // 生活
    //   {
    //     name: '京东',
    //     url: 'https://www.jd.com/',
    //     category_uuid: newCat.uuid,
    //     icon: 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/1ed9aa72f7c16e93671c508b92940af6.png',
    //     type: 1,
    //   },
    //   {
    //     name: '淘宝',
    //     url: 'https://www.taobao.com/',
    //     category_uuid: newCat.uuid,
    //     icon: 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/10eefb28fef91b2d54d7553f76cd99a7.png',
    //     type: 1,
    //   },
    //   {
    //     name: '小红书',
    //     url: 'https://www.xiaohongshu.com/',
    //     category_uuid: newCat.uuid,
    //     icon: 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/8ee77a3c4d9350dcd93c122e021976ba.png',
    //     type: 1,
    //   },
    //   {
    //     name: '大众点评',
    //     url: 'https://www.dianping.com/',
    //     category_uuid: newCat.uuid,
    //     icon: 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/6307a89fa2ff1fba78c59068546eb837.png',
    //     type: 1,
    //   },
    //   {
    //     name: '抖音',
    //     url: 'https://www.douyin.com/',
    //     category_uuid: newCat.uuid,
    //     icon: 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/6178aa1b8406a97a4b0c11642adbfbfb.png',
    //     type: 1,
    //   },
    //   {
    //     name: '携程',
    //     url: 'https://www.ctrip.com/',
    //     category_uuid: newCat.uuid,
    //     icon: 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/c159e65c4f0a3ec48393b217c523b8f6.png',
    //     type: 1,
    //   },
    //   {
    //     name: '去哪儿',
    //     url: 'https://www.qunar.com/',
    //     category_uuid: newCat.uuid,
    //     icon: 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/03411cd794eaf0f9aa713c1b7b653d61.png',
    //     type: 1,
    //   }
    // ];
    const remoteIcons = await getDefaultIcons();
    const bms: Array<IKeyValue> = remoteIcons.data.data;
    for (let i = 0; i < bms.length; i++) {
      // bms[i].type = 1;
      bms[i].order = i + 1;
      bms[i].category_uuid = newCat.uuid;

      if (bms[i].type === 3 && bms[i].attribute) {
        try {
          bms[i].attribute = JSON.parse(bms[i].attribute);
        } catch (err) {
          bms[i].attribute = {};
        }
      } else {
        bms[i].attribute = {};
      }
      await addBookmark(bms[i], false);
    }

    bookmarks.setActive(newCat);

    syncToServer();
  }
  categories.sort((a, b) => {
    return a.order - b.order;
  });
  const objCategories = {};
  categories.forEach((element) => {
    // 如果分类是他人共享的，则取共享uuid作为本地键
    objCategories[element.share_origin_uuid ?? element.uuid] = element;
    element.bookmarks = [];
  });

  const bookmarkList = await getBookmarks();
  bookmarkList.sort((a, b) => {
    return a.order - b.order;
  });

  bookmarkList.forEach((element) => {
    const cat = objCategories[element.category_uuid];
    if (cat) {
      cat.bookmarks.push(element);
    }
  });

  if (categories.length) {
    if (localStorage.getItem('category')) {
      const localCategory = JSON.parse(localStorage.getItem('category'));
      let hasActive = false;
      categories.forEach((item, index) => {
        if (item.uuid === localCategory.uuid) {
          categories[index].active = true;
          hasActive = true;
        } else {
          categories[index].active = false;
        }
      });
      if (!hasActive) {
        categories[0].active = true;
      }
    } else {
      categories[0].active = true;
    }
  }
  bookmarks.setValue(categories);
  console.log('refresh categories', categories);
  localStorage.setItem('categories', JSON.stringify(categories));
  // console.log('bookmarks', bookmarks);
};
